import { FC, PropsWithChildren, TouchEvent, useState } from 'react';

import * as S from './Swipeable.styles';

interface SwipeableFunctionProps {
  onSwipeUp?: () => void;
  onSwipeDown?: () => void;
  threshold?: number;
}

export const Swipeable: FC<PropsWithChildren<SwipeableFunctionProps>> = ({
  children,
  onSwipeUp,
  onSwipeDown,
  threshold = 50
}) => {
  const [startY, setStartY] = useState<number | null>(null);

  const handleTouchStart = (event: TouchEvent) => {
    setStartY(event.touches[0].clientY);
  };

  const handleTouchEnd = (event: TouchEvent) => {
    if (startY === null) {
      return;
    }

    const deltaY = event.changedTouches[0].clientY - startY;

    if (Math.abs(deltaY) >= threshold) {
      if (deltaY < 0) {
        onSwipeUp?.();
      } else {
        onSwipeDown?.();
      }
    }

    setStartY(null);
  };

  return (
    <S.Container onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
      {children}
    </S.Container>
  );
};
